import { SCENARIO_DESCRIPTOR_CONDITION } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(SCENARIO_DESCRIPTOR_CONDITION);
const actions = { ...rawActions, ...thunkFactory(SCENARIO_DESCRIPTOR_CONDITION, '/scenarios_descriptors_conditions/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(SCENARIO_DESCRIPTOR_CONDITION, initialState);

// SAGAS
const sagas = sagasFactory(SCENARIO_DESCRIPTOR_CONDITION, '/scenarios_descriptors_conditions/', { scopedByAccount: true });
export { sagas };
